import Vue from 'vue';
import App from './App';
import router from '@/router';
import i18n from '@/plugins/i18n';
import VueMeta from 'vue-meta';
// import VueThailandAddress from 'vue-thailand-address';
import VueThailandAddress from '@/plugins/vue-thailand-address';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import VueToastr from "vue-toastr";
import Clipboard from 'v-clipboard'
import store from '@/store/main.js';
import Cookies from 'js-cookie'
import { authRead } from '@/store/auth.js'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import storeIndex from '@/store/index';
import config from '@/configure/index.js';
import ThaiAddressInput from '@/plugins/vue-thai-address-input/dist/vue-thai-address-input.esm.js';
require('@/plugins/vue-thai-address-input/dist/vue-thai-address-input.min.css');
import { can } from '@/common/tenancy/permission.utils.js';
import * as VueGoogleMaps from 'vue2-google-maps'
import Embed from 'v-video-embed';
import VueCryptojs from 'vue-cryptojs'
import _ from 'lodash'
// import VueCompositionApi from '@vue/composition-api';

Vue.prototype.$config = config
Vue.prototype.$storeIndex = storeIndex
Vue.prototype.$cookie = Cookies
Vue.prototype.$auth = authRead()
Vue.prototype.$can = can;

const refresh = Vue.observable({ refresh: 0 });
Object.defineProperty(Vue.prototype, '$refresh', {
  get() { return refresh.refresh; },
  set(value) { refresh.refresh = value; }
});

const refreshTopbarWallet = Vue.observable({ refreshTopbarWallet: 0 });
Object.defineProperty(Vue.prototype, '$refreshTopbarWallet', {
  get() { return refreshTopbarWallet.refreshTopbarWallet; },
  set(value) { refreshTopbarWallet.refreshTopbarWallet = value; }
});

const refreshalert = Vue.observable({ refreshalert: 0 });
Object.defineProperty(Vue.prototype, '$refreshalert', {
  get() { return refreshalert.refreshalert; },
  set(value) { refreshalert.refreshalert = value; }
});

const refreshalertexceed = Vue.observable({ refreshalertexceed: 0 });
Object.defineProperty(Vue.prototype, '$refreshalertexceed', {
  get() { return refreshalertexceed.refreshalertexceed; },
  set(value) { refreshalertexceed.refreshalertexceed = value; }
});

const refreshSubscriptionExpiredModal = Vue.observable({ refreshSubscriptionExpiredModal: 0 });
Object.defineProperty(Vue.prototype, '$refreshSubscriptionExpiredModal', {
  get() { return refreshSubscriptionExpiredModal.refreshSubscriptionExpiredModal; },
  set(value) { refreshSubscriptionExpiredModal.refreshSubscriptionExpiredModal = value; }
});

Vue.use(VueMeta);
Vue.use(Clipboard);
Vue.use(VueSweetalert2);
Vue.use(ThaiAddressInput);
Vue.config.productionTip = false
Vue.directive('tooltip', function(el, binding) {
  $(function () {
    $(el).tooltip({
        title: binding.value,
        placement: binding.arg,
        trigger: 'hover'
    })
  })
});
Vue.use(Vuelidate);
Vue.use(VueToastr, {
    defaultTimeout: 5000,
    defaultProgressBar: true,
    defaultPosition: "toast-top-right",
    defaultClickClose: true,
});

Vue.use(VueThailandAddress);
router.beforeEach((to, from, next) => {
        $(".content-wrapper").removeClass("overflow-visible");
        Vue.prototype.$setLayout = to
        $('.popover').remove();
        next()
    })
    /* eslint-disable no-new */
Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyC5U4jVkouUI7K1fFNHlVeIi54ukTVt4mk',
      libraries: 'places',
    },
})
Vue.config.productionTip = false;
Vue.use(VueCryptojs)

new Vue({
    el: '#app',
    router,
    i18n,
    axios,
    store,
    VueToastr,
    components: { App },
    template: '<App/>'
});

Vue.use(Embed);
// Vue.use(VueCompositionApi);


// WEBPACK FOOTER //
// ./src/main.js